import ReusableConsumerSearch from './ReusableConsumerSearch';

export default ReusableConsumerSearch;
